/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgRouteImport } from './routes/_org'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as PreviewIndexRouteImport } from './routes/preview/index'
import { Route as OrgProjectProjectIdDashboardsRouteImport } from './routes/_org/project/$projectId/_dashboards'
import { Route as InviteAcceptInviteIdIndexRouteImport } from './routes/invite/accept/$inviteId/index'
import { Route as OrgProjectProjectIdDashboardsIndexRouteImport } from './routes/_org/project/$projectId/_dashboards/index'
import { Route as OrgProjectProjectIdDashboardsBudgetOptimizationRouteImport } from './routes/_org/project/$projectId/_dashboards/budget-optimization'
import { Route as OrgProjectProjectIdDashboardsCampaignPlannerRouteImport } from './routes/_org/project/$projectId/_dashboards/campaign-planner'
import { Route as OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRouteImport } from './routes/_org/project/$projectId/_dashboards/competitors-media-investment'
import { Route as OrgProjectProjectIdDashboardsExecutiveSummaryRouteImport } from './routes/_org/project/$projectId/_dashboards/executive-summary'
import { Route as OrgProjectProjectIdDashboardsModelContributionsRouteImport } from './routes/_org/project/$projectId/_dashboards/model-contributions'
import { Route as OrgProjectProjectIdDashboardsReportsRouteImport } from './routes/_org/project/$projectId/_dashboards/reports'
import { Route as OrgProjectProjectIdDashboardsSpendSummaryRouteImport } from './routes/_org/project/$projectId/_dashboards/spend-summary'
import { Route as OrgProjectProjectIdDashboardsCampaignOptimizationIndexRouteImport } from './routes/_org/project/$projectId/_dashboards/campaign-optimization.index'
import { Route as OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRouteImport } from './routes/_org/project/$projectId/_dashboards/campaign-optimization.$campaignId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewIndexRoute = PreviewIndexRouteImport.update({
  id: '/preview/',
  path: '/preview/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgProjectProjectIdDashboardsRoute =
  OrgProjectProjectIdDashboardsRouteImport.update({
    id: '/project/$projectId/_dashboards',
    path: '/project/$projectId',
    getParentRoute: () => OrgRoute,
  } as any)
const InviteAcceptInviteIdIndexRoute =
  InviteAcceptInviteIdIndexRouteImport.update({
    id: '/invite/accept/$inviteId/',
    path: '/invite/accept/$inviteId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrgProjectProjectIdDashboardsIndexRoute =
  OrgProjectProjectIdDashboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsBudgetOptimizationRoute =
  OrgProjectProjectIdDashboardsBudgetOptimizationRouteImport.update({
    id: '/budget-optimization',
    path: '/budget-optimization',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsCampaignPlannerRoute =
  OrgProjectProjectIdDashboardsCampaignPlannerRouteImport.update({
    id: '/campaign-planner',
    path: '/campaign-planner',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute =
  OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRouteImport.update({
    id: '/competitors-media-investment',
    path: '/competitors-media-investment',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsExecutiveSummaryRoute =
  OrgProjectProjectIdDashboardsExecutiveSummaryRouteImport.update({
    id: '/executive-summary',
    path: '/executive-summary',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsModelContributionsRoute =
  OrgProjectProjectIdDashboardsModelContributionsRouteImport.update({
    id: '/model-contributions',
    path: '/model-contributions',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsReportsRoute =
  OrgProjectProjectIdDashboardsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsSpendSummaryRoute =
  OrgProjectProjectIdDashboardsSpendSummaryRouteImport.update({
    id: '/spend-summary',
    path: '/spend-summary',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute =
  OrgProjectProjectIdDashboardsCampaignOptimizationIndexRouteImport.update({
    id: '/campaign-optimization/',
    path: '/campaign-optimization/',
    getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
  } as any)
const OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute =
  OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRouteImport.update(
    {
      id: '/campaign-optimization/$campaignId',
      path: '/campaign-optimization/$campaignId',
      getParentRoute: () => OrgProjectProjectIdDashboardsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/preview/': typeof PreviewIndexRoute
  '/project/$projectId': typeof OrgProjectProjectIdDashboardsRouteWithChildren
  '/invite/accept/$inviteId/': typeof InviteAcceptInviteIdIndexRoute
  '/project/$projectId/budget-optimization': typeof OrgProjectProjectIdDashboardsBudgetOptimizationRoute
  '/project/$projectId/campaign-planner': typeof OrgProjectProjectIdDashboardsCampaignPlannerRoute
  '/project/$projectId/competitors-media-investment': typeof OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute
  '/project/$projectId/executive-summary': typeof OrgProjectProjectIdDashboardsExecutiveSummaryRoute
  '/project/$projectId/model-contributions': typeof OrgProjectProjectIdDashboardsModelContributionsRoute
  '/project/$projectId/reports': typeof OrgProjectProjectIdDashboardsReportsRoute
  '/project/$projectId/spend-summary': typeof OrgProjectProjectIdDashboardsSpendSummaryRoute
  '/project/$projectId/': typeof OrgProjectProjectIdDashboardsIndexRoute
  '/project/$projectId/campaign-optimization/$campaignId': typeof OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute
  '/project/$projectId/campaign-optimization/': typeof OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/preview': typeof PreviewIndexRoute
  '/invite/accept/$inviteId': typeof InviteAcceptInviteIdIndexRoute
  '/project/$projectId/budget-optimization': typeof OrgProjectProjectIdDashboardsBudgetOptimizationRoute
  '/project/$projectId/campaign-planner': typeof OrgProjectProjectIdDashboardsCampaignPlannerRoute
  '/project/$projectId/competitors-media-investment': typeof OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute
  '/project/$projectId/executive-summary': typeof OrgProjectProjectIdDashboardsExecutiveSummaryRoute
  '/project/$projectId/model-contributions': typeof OrgProjectProjectIdDashboardsModelContributionsRoute
  '/project/$projectId/reports': typeof OrgProjectProjectIdDashboardsReportsRoute
  '/project/$projectId/spend-summary': typeof OrgProjectProjectIdDashboardsSpendSummaryRoute
  '/project/$projectId': typeof OrgProjectProjectIdDashboardsIndexRoute
  '/project/$projectId/campaign-optimization/$campaignId': typeof OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute
  '/project/$projectId/campaign-optimization': typeof OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_org': typeof OrgRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/preview/': typeof PreviewIndexRoute
  '/_org/project/$projectId/_dashboards': typeof OrgProjectProjectIdDashboardsRouteWithChildren
  '/invite/accept/$inviteId/': typeof InviteAcceptInviteIdIndexRoute
  '/_org/project/$projectId/_dashboards/budget-optimization': typeof OrgProjectProjectIdDashboardsBudgetOptimizationRoute
  '/_org/project/$projectId/_dashboards/campaign-planner': typeof OrgProjectProjectIdDashboardsCampaignPlannerRoute
  '/_org/project/$projectId/_dashboards/competitors-media-investment': typeof OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute
  '/_org/project/$projectId/_dashboards/executive-summary': typeof OrgProjectProjectIdDashboardsExecutiveSummaryRoute
  '/_org/project/$projectId/_dashboards/model-contributions': typeof OrgProjectProjectIdDashboardsModelContributionsRoute
  '/_org/project/$projectId/_dashboards/reports': typeof OrgProjectProjectIdDashboardsReportsRoute
  '/_org/project/$projectId/_dashboards/spend-summary': typeof OrgProjectProjectIdDashboardsSpendSummaryRoute
  '/_org/project/$projectId/_dashboards/': typeof OrgProjectProjectIdDashboardsIndexRoute
  '/_org/project/$projectId/_dashboards/campaign-optimization/$campaignId': typeof OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute
  '/_org/project/$projectId/_dashboards/campaign-optimization/': typeof OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/login'
    | '/auth/logout'
    | '/preview/'
    | '/project/$projectId'
    | '/invite/accept/$inviteId/'
    | '/project/$projectId/budget-optimization'
    | '/project/$projectId/campaign-planner'
    | '/project/$projectId/competitors-media-investment'
    | '/project/$projectId/executive-summary'
    | '/project/$projectId/model-contributions'
    | '/project/$projectId/reports'
    | '/project/$projectId/spend-summary'
    | '/project/$projectId/'
    | '/project/$projectId/campaign-optimization/$campaignId'
    | '/project/$projectId/campaign-optimization/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/login'
    | '/auth/logout'
    | '/preview'
    | '/invite/accept/$inviteId'
    | '/project/$projectId/budget-optimization'
    | '/project/$projectId/campaign-planner'
    | '/project/$projectId/competitors-media-investment'
    | '/project/$projectId/executive-summary'
    | '/project/$projectId/model-contributions'
    | '/project/$projectId/reports'
    | '/project/$projectId/spend-summary'
    | '/project/$projectId'
    | '/project/$projectId/campaign-optimization/$campaignId'
    | '/project/$projectId/campaign-optimization'
  id:
    | '__root__'
    | '/'
    | '/_org'
    | '/auth/login'
    | '/auth/logout'
    | '/preview/'
    | '/_org/project/$projectId/_dashboards'
    | '/invite/accept/$inviteId/'
    | '/_org/project/$projectId/_dashboards/budget-optimization'
    | '/_org/project/$projectId/_dashboards/campaign-planner'
    | '/_org/project/$projectId/_dashboards/competitors-media-investment'
    | '/_org/project/$projectId/_dashboards/executive-summary'
    | '/_org/project/$projectId/_dashboards/model-contributions'
    | '/_org/project/$projectId/_dashboards/reports'
    | '/_org/project/$projectId/_dashboards/spend-summary'
    | '/_org/project/$projectId/_dashboards/'
    | '/_org/project/$projectId/_dashboards/campaign-optimization/$campaignId'
    | '/_org/project/$projectId/_dashboards/campaign-optimization/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrgRoute: typeof OrgRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  PreviewIndexRoute: typeof PreviewIndexRoute
  InviteAcceptInviteIdIndexRoute: typeof InviteAcceptInviteIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_org': {
      id: '/_org'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/': {
      id: '/preview/'
      path: '/preview'
      fullPath: '/preview/'
      preLoaderRoute: typeof PreviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_org/project/$projectId/_dashboards': {
      id: '/_org/project/$projectId/_dashboards'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/invite/accept/$inviteId/': {
      id: '/invite/accept/$inviteId/'
      path: '/invite/accept/$inviteId'
      fullPath: '/invite/accept/$inviteId/'
      preLoaderRoute: typeof InviteAcceptInviteIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_org/project/$projectId/_dashboards/': {
      id: '/_org/project/$projectId/_dashboards/'
      path: '/'
      fullPath: '/project/$projectId/'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsIndexRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/budget-optimization': {
      id: '/_org/project/$projectId/_dashboards/budget-optimization'
      path: '/budget-optimization'
      fullPath: '/project/$projectId/budget-optimization'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsBudgetOptimizationRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/campaign-planner': {
      id: '/_org/project/$projectId/_dashboards/campaign-planner'
      path: '/campaign-planner'
      fullPath: '/project/$projectId/campaign-planner'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsCampaignPlannerRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/competitors-media-investment': {
      id: '/_org/project/$projectId/_dashboards/competitors-media-investment'
      path: '/competitors-media-investment'
      fullPath: '/project/$projectId/competitors-media-investment'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/executive-summary': {
      id: '/_org/project/$projectId/_dashboards/executive-summary'
      path: '/executive-summary'
      fullPath: '/project/$projectId/executive-summary'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsExecutiveSummaryRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/model-contributions': {
      id: '/_org/project/$projectId/_dashboards/model-contributions'
      path: '/model-contributions'
      fullPath: '/project/$projectId/model-contributions'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsModelContributionsRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/reports': {
      id: '/_org/project/$projectId/_dashboards/reports'
      path: '/reports'
      fullPath: '/project/$projectId/reports'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsReportsRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/spend-summary': {
      id: '/_org/project/$projectId/_dashboards/spend-summary'
      path: '/spend-summary'
      fullPath: '/project/$projectId/spend-summary'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsSpendSummaryRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/campaign-optimization/': {
      id: '/_org/project/$projectId/_dashboards/campaign-optimization/'
      path: '/campaign-optimization'
      fullPath: '/project/$projectId/campaign-optimization/'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsCampaignOptimizationIndexRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
    '/_org/project/$projectId/_dashboards/campaign-optimization/$campaignId': {
      id: '/_org/project/$projectId/_dashboards/campaign-optimization/$campaignId'
      path: '/campaign-optimization/$campaignId'
      fullPath: '/project/$projectId/campaign-optimization/$campaignId'
      preLoaderRoute: typeof OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRouteImport
      parentRoute: typeof OrgProjectProjectIdDashboardsRoute
    }
  }
}

interface OrgProjectProjectIdDashboardsRouteChildren {
  OrgProjectProjectIdDashboardsBudgetOptimizationRoute: typeof OrgProjectProjectIdDashboardsBudgetOptimizationRoute
  OrgProjectProjectIdDashboardsCampaignPlannerRoute: typeof OrgProjectProjectIdDashboardsCampaignPlannerRoute
  OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute: typeof OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute
  OrgProjectProjectIdDashboardsExecutiveSummaryRoute: typeof OrgProjectProjectIdDashboardsExecutiveSummaryRoute
  OrgProjectProjectIdDashboardsModelContributionsRoute: typeof OrgProjectProjectIdDashboardsModelContributionsRoute
  OrgProjectProjectIdDashboardsReportsRoute: typeof OrgProjectProjectIdDashboardsReportsRoute
  OrgProjectProjectIdDashboardsSpendSummaryRoute: typeof OrgProjectProjectIdDashboardsSpendSummaryRoute
  OrgProjectProjectIdDashboardsIndexRoute: typeof OrgProjectProjectIdDashboardsIndexRoute
  OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute: typeof OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute
  OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute: typeof OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute
}

const OrgProjectProjectIdDashboardsRouteChildren: OrgProjectProjectIdDashboardsRouteChildren =
  {
    OrgProjectProjectIdDashboardsBudgetOptimizationRoute:
      OrgProjectProjectIdDashboardsBudgetOptimizationRoute,
    OrgProjectProjectIdDashboardsCampaignPlannerRoute:
      OrgProjectProjectIdDashboardsCampaignPlannerRoute,
    OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute:
      OrgProjectProjectIdDashboardsCompetitorsMediaInvestmentRoute,
    OrgProjectProjectIdDashboardsExecutiveSummaryRoute:
      OrgProjectProjectIdDashboardsExecutiveSummaryRoute,
    OrgProjectProjectIdDashboardsModelContributionsRoute:
      OrgProjectProjectIdDashboardsModelContributionsRoute,
    OrgProjectProjectIdDashboardsReportsRoute:
      OrgProjectProjectIdDashboardsReportsRoute,
    OrgProjectProjectIdDashboardsSpendSummaryRoute:
      OrgProjectProjectIdDashboardsSpendSummaryRoute,
    OrgProjectProjectIdDashboardsIndexRoute:
      OrgProjectProjectIdDashboardsIndexRoute,
    OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute:
      OrgProjectProjectIdDashboardsCampaignOptimizationCampaignIdRoute,
    OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute:
      OrgProjectProjectIdDashboardsCampaignOptimizationIndexRoute,
  }

const OrgProjectProjectIdDashboardsRouteWithChildren =
  OrgProjectProjectIdDashboardsRoute._addFileChildren(
    OrgProjectProjectIdDashboardsRouteChildren,
  )

interface OrgRouteChildren {
  OrgProjectProjectIdDashboardsRoute: typeof OrgProjectProjectIdDashboardsRouteWithChildren
}

const OrgRouteChildren: OrgRouteChildren = {
  OrgProjectProjectIdDashboardsRoute:
    OrgProjectProjectIdDashboardsRouteWithChildren,
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrgRoute: OrgRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  PreviewIndexRoute: PreviewIndexRoute,
  InviteAcceptInviteIdIndexRoute: InviteAcceptInviteIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
